<template>
    <div class="main-wrapper">
        <layout-header />

        <div>
            <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
                :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/details-partner-bg.jpg')+');'">
                <div class="container px-4 pt-3 pt-lg-5 mx-auto position-relative" style="z-index: 1">
                    <figure class="bg-white rounded-xl p-2 d-inline-block mb-2" style="max-width: 100px" >
                        <img :src="logo || defaultLogo" class="w-100 h-auto">
                    </figure>
                    <h1 class="font-weight-bold text-white">{{ establishment.business_name }}</h1>
                    <address class="my-2">
                        <p class="text-sm text-white">{{ establishment.address }}, {{ establishment.delegation }}</p>
                    </address>
                    <div class="d-block d-sm-flex align-items-center font-weight-semibold text-white my-2">
                        <a :href="'mailto:'+establishment.email" class="d-flex align-items-center mr-3">
                            <span class="material-symbols-outlined text-sm text-white mr-1">mail</span>
                            <p class="text-sm text-white">{{ establishment.email }}</p>
                        </a>
                        <a :href="'https://www.google.com/maps/search/?api=1&amp;query='+establishment.latitude+','+establishment.longitude"
                            target="_blank" rel="noreferrer" class="d-flex align-items-center">
                            <span class="material-symbols-outlined text-sm text-white mr-1">location_on</span>
                            <p class="text-sm text-white">Obtenir Directions</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="d-flex container justify-content-between align-items-center sticky-top border-bottom mb-3 bg-white px-2 pt-3" style="top: 86px">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'facilities' }"
                            @click.prevent="scrollTo('facilities')">Terrains</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'business_hours' }"
                            @click.prevent="scrollTo('business_hours')">Horaires</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" style="width: max-content !important;" :class="{ active: activeSection === 'about' }"
                            @click.prevent="scrollTo('about')">À Propos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'photos' }"
                            @click.prevent="scrollTo('photos')">Photos</a>
                    </li>
                </ul>
            </div>
            <div class="container mb-5 pb-5">
                <section id="facilities" class="mb-5">
                    <div class="row px-3">
                        <!-- <div class="col-lg-3 col-md-4 col-6" v-for="slot in slots">
                            <div class="border rounded-xl my-2" :class="{ 'bg-light': !slot.available && ( !slot.expires_at || slot.expires_at >= now )}">
                                <div>
                                    <div class="d-flex justify-content-between align-items-center pl-3 pr-2 pt-3">
                                        <h5 class="m-0">
                                            <i class="far fa-clock pr-1"></i>
                                            {{ formatTime(slot.start_time) }} - {{ formatTime(slot.end_time) }}
                                        </h5>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center p-3">
                                        <h4 class="flex-fill m-0 text-muted">
                                            <b v-if="!slot.sale_price">{{ slot.price }}<sup>DT</sup></b>
                                            <s class="mr-1" v-if="slot.sale_price">{{ slot.price }}<sup>DT</sup></s>
                                            <b v-if="slot.sale_price">{{ slot.sale_price }}<sup>DT</sup></b>
                                        </h4>
                                        <div>
                                            <span class="badge badge-pill bg-secondary-light p-2"
                                                v-if="slot.available && slot.start_time <= now">
                                                expiré
                                            </span>
                                            <span class="badge badge-pill bg-success-light p-2"
                                                v-else-if="(slot.available || ( slot.expires_at && slot.expires_at <= now ) ) && slot.start_time > now">disponible</span>
                                            <span class="badge badge-pill bg-warning-light p-2"
                                                v-else-if="!slot.available && slot.expires_at && slot.expires_at > now && slot.start_time > now">
                                                en cours</span>
                                            <span class="badge badge-pill bg-danger-light p-2"
                                                v-else-if="slot.available">réservé</span>
                                        </div>
                                    </div>
                                    <div class="w-100 px-3 pb-3 pt-0">
                                        <button type="button" v-if="slot.available || ( slot.expires_at && slot.expires_at <= now )"
                                            class="btn btn-secondary rounded-xl w-100" @click="prebook(slot)">Réserver</button>
                                        <button type="button" v-else disabled
                                            class="btn btn-secondary rounded-xl w-100">Réserver</button>    
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-lg-3 col-md-4 col-6 mb-3 px-md-2 px-lg-3" v-for="(facility, index) in facilities" :key="facility.id"
                            :class="{'pl-2 pr-0': index % 2 !== 0, 'pl-0 pr-2': index % 2 === 0}">
                            <div>
                                <div
                                    class="border bg-white d-flex flex-column rounded-xl overflow-hidden h-100">
                                    <div class="overflow-hidden position-relative" style="aspect-ratio: 16 / 9;">
                                        <img :src="getFeaturedImage(facility) || defaultFeaturedImage"
                                            class="w-100 h-100 object-cover" loading="lazy">
                                    </div>
                                    <div class="m-0 p-md-3 p-2">
                                        <div class="d-flex justify-content-start align-items-center">
                                            <span class="overflow-hidden whitespace-nowrap h5">
                                                <span v-if="!facility.name.toLowerCase().includes('terrain')">Terrain</span>
                                                {{ facility.name }}
                                            </span>
                                        </div>
                                        <div class="d-flex justify-content-start align-items-center text-xs text-muted pb-1">
                                            <span class="material-symbols-outlined text-lg mr-2">groups</span>
                                            <span class="mr-3">{{ facility.capacity/2 }}v{{ facility.capacity/2 }}</span>
                                            <span class="material-symbols-outlined text-lg mr-2">payments</span>
                                            <span>{{ facility.price }}<sup>DT</sup></span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-start">
                                                <span v-for="n in 5" :key="n"
                                                    :class="{ 'text-primary': n <= Math.round(facility.average_rating), 'text-light': n > Math.round(facility.average_rating) }"
                                                    class="material-icons text-md">
                                                    star
                                                </span>
                                            </div>
                                            <a class="btn btn-primary rounded-pill text-xs text-dark p-1" :href="`/book/facility/${facility.id}-${generateSlug(['terrain', facility.name, establishment.business_name, establishment.delegation].join(' '))}`">
                                                <b>Réserver</b>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="business_hours" class="mb-5">
                    <h3><b>Horaires et Emplacement</b></h3>
                    <div class="row mx-0 my-3 d-flex align-items-stretch">
                        <div class="col-lg-4 col-md-5 col-sm-5 bg-light rounded-xl my-1 p-3">
                            <span class="d-block mb-3 text-sm">{{ establishment.address }}, {{ establishment.delegation }}</span>
                            <div class="d-flex flex-row justify-content-between align-items-center my-1"
                                v-for="businessDay in establishment.business_hours" :key="businessDay.day" style="min-height: 31px;">
                                <span class="pl-0 text-left" style="width: 100px;">{{ getDayNameInFrench(businessDay.day) }}</span>
                                <div v-if="businessDay.is_active">
                                    <span>{{ businessDay.open }} - {{ businessDay.close }}</span>
                                </div>
                                <div v-if="!businessDay.is_active">
                                    <span class="badge bg-danger-light py-2 px-3 rounded-pill">Fermé</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-7 col-sm-7 rounded-xl my-1 px-0 pl-sm-3">
                            <GoogleMap class="rounded-xl bg-light h-100 overflow-hidden" style="min-height: 300px;" :center="mapCenter" :zoom="18" :options="{
                                mapTypeId: 'hybrid',
                            }" />
                        </div>
                    </div>
                </section>
                <section id="about" style="min-height: 400px;">
                    <h3><b>À Propos</b></h3>
                </section>
                <section id="photos" style="min-height: 400px;">
                    <h3><b>Gallerie Photos</b></h3>
                </section>
            </div>
        </div>

        <layout-footer />
    </div>
</template>
<style lang="css">
.nav-tabs.nav-justified > li > a {
    cursor: pointer;
}
</style>
<script>
import { GoogleMap } from 'vue3-google-map'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/photo.png'
import defaultFeaturedImagePath from '@/assets/img/blog/blog-01.jpg'

export default {
    components: {
        vSelect,
        GoogleMap
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    },
    props: ['id'],
    data() {
        return {
            establishment: {},
            facilities: [],
            sections: [
                { id: 'facilities', label: 'Terrains' },
                { id: 'business_hours', label: 'Horaires' },
                { id: 'about', label: 'À Propos' },
                { id: 'photos', label: 'Gallerie' }
            ],
            activeSection: '',
            now: moment().format('YYYY-MM-DDTHH:mm:ss'),
            date: moment().format('YYYY-MM-DD'),
            logo: null,
            defaultLogo: defaultLogoPath,
            defaultFeaturedImage: defaultFeaturedImagePath,
            mapCenter: { lat: 36.8065, lng: 10.1815 },
        }
    },
    created() {
        this.getEstablishment()
    },
    methods: {
        generateSlug(text) {
            if (!text) return '';

            return text
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/[\s_]+/g, '-')
                .replace(/-+/g, '-');
        },
        getEstablishment() {
            api.get('/search/establishments/' + this.id)
                .then(response => {
                    const result = response.data
                    this.establishment = result
                    this.facilities = this.establishment.facilities
                    this.logo = this.establishment.logo_url
                    this.mapCenter.lat = this.establishment.latitude
                    this.mapCenter.lng = this.establishment.longitude
                })
        },
        getFeaturedImage(facility) {
            if (this.isEmpty(facility)) return null
            const featuredImage = facility.images.filter(img => img.role === 'featured')
            if (featuredImage.length > 0) return featuredImage[0]['thumb_large_url']
            return null
        },
        setRating(n, index) {
            this.establishments[index].rating = n;
        },
        getDayNameInFrench(dayName) {
            const referenceDays = {
                Sunday: 'Dimanche',
                Monday: 'Lundi',
                Tuesday: 'Mardi',
                Wednesday: 'Mercredi',
                Thursday: 'Jeudi',
                Friday: 'Vendredi',
                Saturday: 'Samedi'
            };
            return referenceDays[dayName]
        },
        formatTime(datetimeString) {
            if (!datetimeString) return '';
            const date = new Date(datetimeString);
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        formatLabel(option) {
            if (!option || typeof option !== "string") return "";
            const [delegation, state] = option.split(", ");
            return '<b>' + delegation + '</b>, ' + state;
        },
        isEmpty(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        },
        scrollTo(id) {
            const el = document.getElementById(id)
            if (el) {
                const yOffset = -173 // offset for sticky nav
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
                window.scrollTo({ top: y, behavior: 'smooth' })
            }
        },
        handleScroll() {
            for (const section of this.sections) {
                const el = document.getElementById(section.id)
                if (el) {
                    const rect = el.getBoundingClientRect()
                    if (rect.top <= 180 && rect.bottom >= 180) {
                        this.activeSection = section.id
                        break
                    }
                }
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {}
}
</script>
